// extracted by mini-css-extract-plugin
export default {"playButton":"styles__playButton___6kz3+","playButtonLabel":"styles__playButtonLabel___EskEZ"};